import { render } from "./PresuGeneral.vue?vue&type=template&id=53ece166&scoped=true"
import script from "./PresuGeneral.vue?vue&type=script&lang=js"
export * from "./PresuGeneral.vue?vue&type=script&lang=js"

import "./PresuGeneral.vue?vue&type=style&index=0&id=53ece166&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53ece166"

export default script